import React, { lazy, Suspense, useEffect, useState } from "react"
import PubSub from "pubsub-js"
import { PLAYER_STATE_TOPIC, isPlayerOpen } from "./player"

const Widget = lazy(() => import("./support-chat/SupportChatWidget"))

/**
 * Storefront support chat as a client-only island, mounted on every page
 * after load (the old site kept the chat mounted so the floating button, the
 * unread badge and the background polling were always there); the bundle is
 * loaded when the browser is idle, so pages stay light. The widget itself
 * (support-chat/SupportChatWidget.jsx) talks to POST /v1/support-chat: the
 * aldoo-agent support assistant plus the hand-off to a human agent.
 */
export default function SupportChat() {
  const [ready, setReady] = useState(false)
  // the player takes the whole screen; the floating button would sit on top
  // of its controls
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    setHidden(isPlayerOpen())
    const token = PubSub.subscribe(PLAYER_STATE_TOPIC, (_, data) => setHidden(!!data?.open))
    return () => PubSub.unsubscribe(token)
  }, [])

  useEffect(() => {
    const start = () => setReady(true)
    if ("requestIdleCallback" in window) {
      const id = window.requestIdleCallback(start, { timeout: 4000 })
      return () => window.cancelIdleCallback(id)
    }
    const id = setTimeout(start, 1500)
    return () => clearTimeout(id)
  }, [])

  if (!ready) return null
  // kept mounted while the player plays, so an answer that arrives meanwhile
  // is still waiting when the reader comes back
  return (
    <div style={hidden ? { display: "none" } : undefined} data-testid="support-chat" data-hidden={hidden ? "1" : "0"}>
      <Suspense fallback={null}>
        <Widget />
      </Suspense>
    </div>
  )
}
